import React from 'react';
import { Region } from 'root/main/components/regionalLogos/types';
interface DebugProps {
    region: Region;
    reactProductType: string | undefined;
}
export default function Debug({ region, reactProductType }: DebugProps) {
    return (
        <div
            style={{
                backgroundColor: 'green',
                color: 'white',
                fontSize: '14px',
                fontWeight: 'bold',
                textAlign: 'center',
            }}
        >
            <p>
                Region: {region.country_code}
                {region.state_code ? `_${region.state_code}` : ''} || Product Type:{' '}
                {reactProductType}
            </p>
        </div>
    );
}
